/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FileLoader from '../utilities/FileLoader';

// This is a bit of an odd component, it renders a hidden file input and relies on the parent component to invoke openFileSelector using a ref
export default class SVGFileInput extends Component {
	static propTypes = {
		successCallback: PropTypes.func.isRequired,
		failCallback: PropTypes.func.isRequired,
		zipMaxSize: PropTypes.number.isRequired,
		imgMaxSize: PropTypes.number.isRequired
	};

	constructor(props) {
		super(props);

		this.fileInputRef = null;
		this.replaceIdx = null;
	}

	openFileSelector( isMultiple, replaceIdx ) {
		this.replaceIdx = replaceIdx;
		if ( this.fileInputRef ) {
			this.fileInputRef.multiple = isMultiple;
			this.fileInputRef.click();
		}
	}

	// some utility methods - need to find the name of the image - without path
	_findSourceName = ( name ) => {
		return name.split('/').pop();
	}

	_onFileChange = (e) => {
		let loader = new FileLoader( null, this.props.zipMaxSize, this.props.imgMaxSize );
		loader.load( e.target.files, ( _fileList ) => {
			if ( _fileList.length > 0 ) {
				let sourceNames = [];
				let blobUrls = [];
				let loadBlobPromises = [];

				_fileList.forEach( ( item ) => {
					sourceNames.push( this._findSourceName( item ) );
					blobUrls.push( '' );
					loadBlobPromises.push( loader.getFileAsBlob( item ) );
				} );

				let urlCreator = window.URL || window.webkitURL;
				Promise.all( loadBlobPromises ).then( ( loadedBlobUrls ) => {
					loadedBlobUrls.forEach( ( item, i ) => {
						// item is returned as blob - but it won't have a type
						// so we need to slice it to set the type
						let sliceBlob = item.slice( 0, item.size, 'image/svg+xml' );
						// want to keep the source URL - we need to release it later
						blobUrls[ i ] = urlCreator.createObjectURL( sliceBlob );
					} );
					this.props.successCallback( sourceNames, blobUrls, this.replaceIdx );
				} ).catch( this.props.failCallback );
			}
		},
		this.props.failCallback );
	}

	render () {
		return (
			<div>
				<input
					id='myInput'
					accept='.svg'
					multiple={true}
					value=''
					type='file'
					style={{ display:'none' }}
					ref={(ref) => { this.fileInputRef = ref;} }
					onChange={ this._onFileChange }
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/SVGFileInput.js